import React from "react";
import "./EmpContent.css";
import Content from "./sub-EmpContent/Content";

function EmpContent () {
    return(
        <div className="container">
            <div className="row EmpContentSec">
                <div className="col-12">
                    <Content />
                </div>
            </div>
            <div className="row EmpContentSec">
                <div className="col-12">
                    <Content />
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <Content />
                </div>
            </div>
        </div>
    )
};

export default EmpContent ;